import { render, staticRenderFns } from "./learn_userReport.vue?vue&type=template&id=78234a1c&"
import script from "./learn_userReport.vue?vue&type=script&lang=js&"
export * from "./learn_userReport.vue?vue&type=script&lang=js&"
import style0 from "./learn_userReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports